export const FaqList = [
  {
    id: "headingOne",
    controls: "collapseOne",
    expanded: true,
    btnClass: "",
    contentClass: "show",
    title: "What handyman services do you offer in Kuala Lumpur and Malaysia?",
    details: `FRG Renovation Works provides a complete range of handyman services and home renovation solutions across Kuala Lumpur, Selangor and Malaysia. Our services include plumbing repairs, licensed electrical work, carpentry, drywall repair, painting, flooring installation, kitchen renovation, bathroom remodeling, deep cleaning services, and general home maintenance. Whether you need a handyman near you for small home repair services or a full home renovation contractor, we have the expertise for every project.`,
  },
  {
    id: "headingTwo",
    controls: "collapseTwo",
    expanded: false,
    btnClass: "collapsed",
    contentClass: "",
    title: "Are your handymen licensed, insured and background-checked?",
    details: `Yes. Every handyman on our team is licensed, insured and fully vetted. We carry general liability insurance and worker's compensation coverage, so you are protected at every step. As a trusted local home improvement expert, we only send professional handyman services you can feel safe about inviting into your home.`,
  },
  {
    id: "headingThree",
    controls: "collapseThree",
    expanded: false,
    btnClass: "collapsed",
    contentClass: "",
    title: "How do I schedule a handyman service appointment near me?",
    details: `Booking a handyman near you is easy. Call our office, WhatsApp us, or fill out the online form on our website — one of our friendly customer service representatives will schedule a convenient time for a handyman to visit your home or business. We also offer emergency handyman services in Kuala Lumpur and Selangor for urgent home repair needs.`,
  },
  {
    id: "headingFour",
    controls: "collapseFour",
    expanded: false,
    btnClass: "collapsed",
    contentClass: "",
    title: "Do you offer warranties on handyman and home renovation work?",
    details: `Absolutely. Every project we complete comes with a satisfaction guarantee — if you're not fully happy with our handyman or renovation work, we'll make it right. We also provide warranties on specific services, including a one-year warranty on plumbing and electrical repairs, so you can trust us for long-lasting home improvement and residential repair.`,
  },
  {
    id: "headingFive",
    controls: "collapseFive",
    expanded: false,
    btnClass: "collapsed",
    contentClass: "",
    title: "How much does home renovation or kitchen remodeling cost in Malaysia?",
    details: `The cost of home renovation in Malaysia depends on the scope — kitchen renovation, bathroom remodeling, flooring or full house renovation. We offer affordable renovation services in Kuala Lumpur and Selangor with transparent, itemised quotes. Contact us for a free on-site consultation and a detailed estimate from a professional renovation contractor.`,
  },
  {
    id: "headingSix",
    controls: "collapseSix",
    expanded: false,
    btnClass: "collapsed",
    contentClass: "",
    title: "Do you handle emergency handyman services and same-day home repair?",
    details: `Yes — our emergency handyman services are available for urgent plumbing leaks, electrical faults, broken fixtures and other residential repair emergencies. Our local home repair experts aim for same-day response across Kuala Lumpur, Selangor, Petaling Jaya and surrounding areas.`,
  },
];
